import { Field, NumericInput, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { DateTimeStyle } from 'Components/Layout/Grid/types';
import { WorksheetGridFieldSection, WorksheetRecordGrid } from 'Components/Worksheets/Core';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';
import { getDryMassGridFieldSet } from 'Components/Worksheets/MoistureContentWorksheet/BsEn/gridFieldSets';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { IEmbeddedTestProps } from '../../types';

let BsEnDryMassesSingleTraySection: React.FC<IEmbeddedTestProps> = ({ createWorksheetSelector, isEmbeddedTest }) => {
  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));

  const showSingleReadingSection = useSelector(
    pipe(
      createWorksheetSelector!('DryingTrays[0].DryMassReadings'),
      (r) => (r?.length ?? 0) <= 1 && dryMassEntryOption === 'Never'
    )
  );

  return (
    <>
      {showSingleReadingSection ? (
        <ListFieldSection>
          <Field
            input={<NumericInput />}
            name="DryingTrays[0].DryMassReadings[0].DrySoilAndContainerMass"
            // We do not show the dry mass calculated from the Tare + Dry mass, so we need to show its messages on this field
            additionalMessagePaths={['DryingTrays[0].DryMassReadings[0].DrySoilMass']}
            label="Tare and Material Dry Mass"
          />
        </ListFieldSection>
      ) : (
        <WorksheetGridFieldSection name="DryingTrays[0].DryMassReadings">
          <WorksheetRecordGrid
            name="DryingTrays[0].DryMassReadings"
            orientation="vertical"
            recordProps={{
              enforceAtLeastOneRecord: true,
              preventRemove: 'all-but-last',
              preventCreate: dryMassEntryOption === 'Never',
              removeConfirm: {
                confirm: true,
                confirmTitle: 'Delete Dry Mass Reading',
                confirmText: 'Are you sure you want to delete the dry mass reading? Data cannot be recovered.',
                confirmButtonText: 'Delete',
              },
            }}
            fieldSet={getDryMassGridFieldSet(dryMassEntryOption, DateTimeStyle.Combined)}
          />
        </WorksheetGridFieldSection>
      )}
      <ListFieldSection>
        <Field input={<TextOutput />} name="Measurements.TotalDryMass" label="Material Dry Mass" />
        {isEmbeddedTest && <Field input={<TextOutput />} name="Results.MoistureContentPercent" />}
      </ListFieldSection>
    </>
  );
};

BsEnDryMassesSingleTraySection = withInjectedProps(BsEnDryMassesSingleTraySection);

export { BsEnDryMassesSingleTraySection };
export default BsEnDryMassesSingleTraySection;
